// Direct Cloud Function URLs. Firebase Hosting rewrites have a hard 60s timeout,
// so we bypass them and call the functions directly (which support their full
// configured timeout_sec). Get these URLs from the Firebase Console → Functions,
// or run: gcloud run services list --project=originstamp-velocity --region=europe-west6
export const FUNCTION_URLS = {
  contactResearch: "https://cf-contact-research-yybmdjcffq-oa.a.run.app",
  rescore: "https://cf-rescore-lead-yybmdjcffq-oa.a.run.app",
  personalization: "https://cf-personalized-line-yybmdjcffq-oa.a.run.app",
  // Verify after first deploy — the hash segment matches the other functions.
  functionLogs: "https://cf-function-logs-yybmdjcffq-oa.a.run.app",
  // cf_contacts_api is a callable function — invoked via httpsCallable(),
  // which resolves the URL from the SDK config (see web/src/lib/firebase.ts).
} as const;

export type LoggedFunctionName =
  | "cf_contact_research"
  | "cf_rescore_lead"
  | "cf_personalized_line";
